export const getHostname = (location) => {
    var _a;
    const hostname = location ? location.hostname : (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname;
    return hostname || '';
};
//# sourceMappingURL=getHostname.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
